import ReactGA from "react-ga";
ReactGA.initialize(process.env.REACT_APP_ANALYTICS_ID);

export const handleOnClickLogo = () => {
  ReactGA.event({
    category: "Usuario",
    action: "click",
    label: "Clientes",
  });
};
